import {create} from 'zustand'

type AccountOwnerI = {
  opensooq_member_id: number
  profile_picture: string
  company_mobile: string
  account_owner: string
} | null

type WalletLabelsI = {
  balance_label?: string
  bundle_quantity_label?: string
  bundle_summary_label?: Record<string, string>
} | null

type State = {
  accountOwner: AccountOwnerI
  walletLabels: WalletLabelsI
}

type Actions = {
  setAccountOwner: (accountOwner: AccountOwnerI) => void
  setWalletLabels: (walletLabels: WalletLabelsI) => void
}

const useAccountOwnerStore = create<State & Actions>((set, get, state) => ({
  accountOwner: null,
  walletLabels: null,
  setAccountOwner: (accountOwner) => set({accountOwner}),
  setWalletLabels: (walletLabels) => set({walletLabels}),
}))

export default useAccountOwnerStore
